import { AUDIENCE_RESEARCH_NAME } from '@workspace/common/app';

/** Shared display order keeps the homepage, navigation, and canonical pages aligned.
 * `number` is a stable preview ID, not the item's position in this array.
 */
export const capabilities = [
  {
    number: '01',
    slug: 'prospecting-intelligence',
    title: 'Prospecting intelligence',
    description: 'Find the people worth reaching now.'
  },
  {
    number: '02',
    slug: 'account-intelligence',
    title: 'Account intelligence',
    description: 'Understand what changed and who matters.'
  },
  {
    number: '04',
    slug: 'continuous-account-monitoring',
    title: 'Continuous account monitoring',
    description: 'Follow changes at the accounts you care about.'
  },
  {
    number: '03',
    slug: 'audience-research',
    title: AUDIENCE_RESEARCH_NAME,
    description: 'Know what your audience cares about.'
  },
  {
    number: '05',
    slug: 'competitive-watch',
    title: 'Competitive watch',
    description: 'See competitor messages and the accounts engaging.'
  },
  {
    number: '06',
    slug: 'churn-detection',
    title: 'Churn detection',
    description: 'Surface customer changes for review.'
  }
] as const;

export type Capability = (typeof capabilities)[number];
export type CapabilitySlug = Capability['slug'];

export function getCapability(slug: string): Capability | undefined {
  return capabilities.find((capability) => capability.slug === slug);
}

export function capabilityHref(capability: Capability): string {
  return `/${capability.slug}`;
}

/** Visible numbering follows display order, independently of preview IDs. */
export function capabilityDisplayNumber(capability: Capability): string {
  const index = capabilities.findIndex((item) => item.slug === capability.slug);
  return String(index + 1).padStart(2, '0');
}
